import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminOreStoreDashboard from "../components/AdminOreStoreDashboard";
import AdminOreStoreOffers from "../components/AdminOreStoreOffers";
import AdminOreStoreBBCode from "../components/AdminOreStoreBBCode";
import { Button } from "../components/ui/button";
import { ArrowLeft, Shield } from "lucide-react";

const ORESTORE_LOGO =
  "https://customer-assets.emergentagent.com/job_refinery-hub-4/artifacts/3azwctos_Ore-Store-LOGO2.png";

const OreStoreAdminPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (!user.is_admin && !user.is_orestore_admin) {
      navigate("/");
    }
  }, [user, navigate]);

  if (!user || (!user.is_admin && !user.is_orestore_admin)) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a0e05] via-[#2a1a0e] to-[#1a0e05] text-foreground">
      {/* Header */}
      <div className="border-b-4 border-[#5a3a14] bg-gradient-to-r from-[#3a2814] to-[#2a1a0e] shadow-lg">
        <div className="container mx-auto px-4 py-4 flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/admin")}
            className="text-orange-200"
            data-testid="orestore-admin-back"
          >
            <ArrowLeft className="w-4 h-4 mr-1" /> Admin
          </Button>
          <img src={ORESTORE_LOGO} alt="OreStore" className="h-10 w-auto" />
          <div className="flex-1">
            <h1 className="text-xl sm:text-2xl font-extrabold text-orange-200">
              OreStore Panel
            </h1>
            <div className="text-xs text-orange-300/70 flex items-center gap-1">
              <Shield className="w-3 h-3" />
              {user.is_admin ? "Full Admin access" : "OreStore Admin access"}
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="container mx-auto px-4 py-6 space-y-6" data-testid="orestore-admin-page">
        <AdminOreStoreDashboard />
        <AdminOreStoreOffers />
        <AdminOreStoreBBCode />
      </div>
    </div>
  );
};

export default OreStoreAdminPage;
